import { render, staticRenderFns } from "./PackageContactsList.vue?vue&type=template&id=67301d37&scoped=true&"
import script from "./PackageContactsList.vue?vue&type=script&lang=js&"
export * from "./PackageContactsList.vue?vue&type=script&lang=js&"
import style0 from "./PackageContactsList.vue?vue&type=style&index=0&id=67301d37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67301d37",
  null
  
)

export default component.exports